"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useElementInViewport = require("./useElementInViewport");
Object.keys(_useElementInViewport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useElementInViewport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useElementInViewport[key];
    }
  });
});